import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getOrderPrimaryPhaseDimensionLabel, ORDER_PRIMARY_PHASE_DIMENSION_OPTIONS } from './lib/orderPrimaryPhaseDimension';

const OrderPrimaryPhaseDimensionSwitch = ({ activeDimension, onDimensionChange, className = '', compact = false }) => {
	const [open, setOpen] = useState(false);
	const rootRef = useRef(null);
	const activeLabel = getOrderPrimaryPhaseDimensionLabel(activeDimension);

	useEffect(() => {
		if (!open) return undefined;
		const onDocPointerDown = (event) => {
			if (!rootRef.current?.contains(event.target)) setOpen(false);
		};
		document.addEventListener('mousedown', onDocPointerDown);
		return () => document.removeEventListener('mousedown', onDocPointerDown);
	}, [open]);

	const handleSelect = (value) => {
		onDimensionChange?.(value);
		setOpen(false);
	};

	if (!compact) {
		return (
			<div
				className={['statistics-primary-phase-dimension', className].filter(Boolean).join(' ')}
				role='group'
				aria-label='贡献维度'
			>
				<span className='statistics-primary-phase-dimension__label'>贡献维度</span>
				<div className='statistics-primary-phase-dimension__group'>
					{ORDER_PRIMARY_PHASE_DIMENSION_OPTIONS.map(({ value, label }) => (
						<button
							key={value}
							type='button'
							className={['statistics-primary-phase-dimension__btn', activeDimension === value ? 'is-active' : null].filter(Boolean).join(' ')}
							onClick={() => onDimensionChange?.(value)}
							aria-pressed={activeDimension === value}
						>
							{label}
						</button>
					))}
				</div>
			</div>
		);
	}

	return (
		<div
			ref={rootRef}
			className={[
				'statistics-primary-phase-dimension',
				'statistics-primary-phase-dimension--compact',
				'statistics-primary-phase-dimension--collapsible',
				open ? 'is-open' : null,
				className,
			]
				.filter(Boolean)
				.join(' ')}
		>
			{open ? (
				<>
					<span className='statistics-primary-phase-dimension__label'>贡献维度</span>
					<div className='statistics-primary-phase-dimension__group' role='group' aria-label='选择贡献维度'>
						{ORDER_PRIMARY_PHASE_DIMENSION_OPTIONS.map(({ value, label }) => (
							<button
								key={value}
								type='button'
								className={['statistics-primary-phase-dimension__btn', activeDimension === value ? 'is-active' : null].filter(Boolean).join(' ')}
								onClick={() => handleSelect(value)}
								aria-pressed={activeDimension === value}
							>
								{label}
							</button>
						))}
					</div>
					<button
						type='button'
						className='statistics-primary-phase-dimension__collapse'
						aria-label='收起贡献维度'
						onClick={() => setOpen(false)}
					>
						<FontAwesomeIcon icon='chevron-up' />
					</button>
				</>
			) : (
				<button
					type='button'
					className='statistics-primary-phase-dimension__trigger'
					aria-expanded={false}
					aria-label={`贡献维度：${activeLabel}，展开切换`}
					onClick={() => setOpen(true)}
				>
					<span className='statistics-primary-phase-dimension__label'>贡献维度</span>
					<span className='statistics-primary-phase-dimension__value'>{activeLabel}</span>
					<FontAwesomeIcon icon='chevron-down' className='statistics-primary-phase-dimension__caret' />
				</button>
			)}
		</div>
	);
};

OrderPrimaryPhaseDimensionSwitch.propTypes = {
	activeDimension: PropTypes.string.isRequired,
	onDimensionChange: PropTypes.func,
	className: PropTypes.string,
	compact: PropTypes.bool,
};

export default OrderPrimaryPhaseDimensionSwitch;
